import React, { Component, Fragment } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  ModalHeader,
  Modal,
  Tooltip,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import myma_logo from './../../assets/myma_logo.png';
import { connect } from 'react-redux';
import { registerUser } from '../../redux/actions';
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import {
  postAPI_Verify_User,
  postAPI_Signup_User,
  API_PAGE_CONTENT,
} from '../../constants/APIs';
import IntlMessages from '../../helpers/IntlMessages';
import { Colxx } from '../../components/common/CustomBootstrap';
import queryString from 'query-string';
import PasswordStrengthBar from 'react-password-strength-bar';
import parse from 'html-react-parser';
class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      firstname: '',
      lastname: '',
      password: '',
      creator: 'dashboard',
      success: false,
      isShow: false,
      tooltip: false,
    };
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    console.log(values);
    let data = { data: values.data };
    //  let data = { data: '0NiGF6C1xZBMmcBKNYAHS9BIj0xiavhLqxcVIc171ZcbW/SGhZ9WJLfc/YArjeWrdscqFBgUETavWKanZLfsafTGEpkq+oSRYzCUvAFxDZ+tT+NGk2o+NFCIY1BzH3/p+aGb9HAOwiew35OUMR+Fyw==' };
    AxiosPublicAPI({
      method: 'post',
      url: `${postAPI_Verify_User}`,
      data: data,
    }).then(
      (res) => {
        this.setState({ id: res.data.id });
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );
    AxiosPublicAPI({
      method: 'get',
      url: `${API_PAGE_CONTENT}?provider=${this.extractProvider()}&page=register`,
    }).then(
      (res) => {
        if (
          res.data.contentArea1 !== undefined &&
          res.data.contentArea1 !== null &&
          res.data.contentArea1 !== ''
        )
          this.setState({
            contentArea1: res.data.contentArea1,
          });

        if (
          res.data.contentArea2 !== undefined &&
          res.data.contentArea2 !== null &&
          res.data.contentArea2 !== ''
        )
          this.setState({
            contentArea2: res.data.contentArea2,
          });
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );
  }

  extractProvider() {
    if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.concierge.synxis.com')
    ) {
      return 5;
    } else if (
      window.location.hostname.toLowerCase().startsWith('app.bookmebob.com')
    ) {
      return 1;
    } else if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.devtest.bookmebob.com')
    ) {
      return 1;
    } else if (window.location.hostname.toLowerCase().includes('myma.ai'))
      return 1;
    else return 1;
  }

  redirectAction() {
    if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.concierge.synxis.com')
    ) {
      window.location.href = 'https://app.concierge.synxis.com';
    } else if (
      window.location.hostname.toLowerCase().startsWith('app.bookmebob.com')
    ) {
      window.location.href = 'https://app.bookmebob.com';
    } else if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.devtest.bookmebob.com')
    ) {
      window.location.href = 'https://app.devtest.bookmebob.com';
    } else if (
      window.location.hostname.toLowerCase().startsWith('app.devtest.myma.ai')
    ) {
      window.location.href = 'https://app.devtest.myma.ai';
    } else if (window.location.hostname.toLowerCase().includes('myma.ai'))
      window.location.href = 'https://app.myma.ai';
    else window.location.href = 'https://app.bookmebob.com';
  }

  handleChangeFirstName = (name) => {
    this.setState({
      firstname: name.target.value,
    });
  };

  handleChangeLastName = (name) => {
    this.setState({
      lastname: name.target.value,
    });
  };

  handleChangePassword = (password) => {
    this.setState({
      password: password.target.value,
    });
  };

  onUserRegister() {
    let data = {
      id: this.state.id,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      password: this.state.password,
      creator: 'dashboard',
    };
    var passwordPattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;
    if (
      this.state.password.length >= 12 &&
      this.state.password.length <= 16 &&
      /(?=.*[A-Z])/.test(this.state.password) &&
      /(?=.*[a-z])/.test(this.state.password) &&
      /(?=.*[0-9])/.test(this.state.password) &&
      /(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(this.state.password)
    ) {
      this.setState({ process: true, loading: true });
      AxiosPublicAPI({
        method: 'post',
        url: `${postAPI_Signup_User}`,
        data: data,
      }).then(
        (res) => {
          this.setState({
            success: true,
          });
        },
        (error) => {
          console.log('eee.data', error.data);
        }
      );
    } else this.setState({ isShow: true });
  }

  render() {
    return (
      <Fragment>
        <Row className="h-100">
          <Colxx xxs="12" md="10" className="mx-auto my-auto">
            <Card className="auth-card">
              {this.state?.contentArea1 ? (
                parse(this.state?.contentArea1)
              ) : (
                <div className="position-relative image-side ">
                  <p className="text-white h2">
                    AI-POWERED DIGITAL ASSISTANT FOR HOSPITALITY
                  </p>

                  <p className="white mb-0">
                    Please use this form to register.
                  </p>
                </div>
              )}
              {!this.state.success && (
                <div className="form-side">
                  <NavLink to={`/`} className="white">
                    {this.state?.contentArea2 ? (
                      parse(this.state?.contentArea2)
                    ) : (
                      <span className="logo-single">
                        {' '}
                        <img src={myma_logo} width="150" height="100" />{' '}
                      </span>
                    )}
                  </NavLink>
                  <CardTitle className="mb-4">
                    <IntlMessages id="user.register" />
                  </CardTitle>
                  <div className="m-2">
                    <h6>Your password must contain </h6>
                    <ul className="ml-3">
                      <li className="mb-2">Atleast 12 Characters.</li>
                      <li className="mb-2">Atleast one upper case letter.</li>
                      <li className="mb-2">Atleast one lower case letter.</li>
                      <li className="mb-2">Atleast one number.</li>
                      <li className="mb-2">
                        Atleast one of the following symbols
                        (?=.*[@#$%^&-+=()]).
                      </li>
                    </ul>
                  </div>
                  <Form>
                    <Label className="form-group has-float-label mb-4">
                      <Input
                        className="input_sty"
                        type="firstname"
                        onChange={this.handleChangeFirstName}
                      />
                      <IntlMessages id="user.firstname" />
                    </Label>
                    <Label className="form-group has-float-label mb-4">
                      <Input
                        className="input_sty"
                        type="lastname"
                        onChange={this.handleChangeLastName}
                      />
                      <IntlMessages id="user.lastname" />
                    </Label>
                    {/* <Label className="form-group has-float-label mb-4">
                  <Input type="email" defaultValue={this.state.email} />
                  <IntlMessages id="user.email" />
                </Label> */}
                    <Label
                      className="form-group has-float-label mb-4"
                      id="Tooltip"
                    >
                      <Input
                        className="input_sty"
                        type="password"
                        onChange={this.handleChangePassword}
                      />
                      <IntlMessages id="user.newpassword" />
                    </Label>
                    <Tooltip
                      placement={'right'}
                      isOpen={this.state.tooltip}
                      target={'Tooltip'}
                      toggle={() =>
                        this.setState((prevState) => ({
                          tooltip: !prevState.tooltip,
                        }))
                      }
                    >
                      <p
                        className="text-start"
                        style={{
                          color: `${
                            this.state.password.length >= 12 ? 'green' : 'red'
                          }`,
                        }}
                      >
                        <img
                          src="https://webchat.bookmebob.com/res/close_cross.png"
                          width={10}
                          height={10}
                        ></img>
                        <span className="ml-2">Have atleast 12 characters</span>
                      </p>
                      <p
                        className="text-start"
                        style={{
                          color: `${
                            /(?=.*[A-Z])/.test(this.state.password)
                              ? 'green'
                              : 'red'
                          }`,
                        }}
                      >
                        <img
                          src="https://webchat.bookmebob.com/res/close_cross.png"
                          width={10}
                          height={10}
                        ></img>
                        <span className="ml-2">
                          Have atleast one upper case character
                        </span>
                      </p>
                      <p
                        className="text-start"
                        style={{
                          color: `${
                            /(?=.*[a-z])/.test(this.state.password)
                              ? 'green'
                              : 'red'
                          }`,
                        }}
                      >
                        <img
                          src="https://webchat.bookmebob.com/res/close_cross.png"
                          width={10}
                          height={10}
                        ></img>
                        <span className="ml-2">
                          Have atleast one lower case character
                        </span>
                      </p>
                      <p
                        className="text-start"
                        style={{
                          color: `${
                            /(?=.*[0-9])/.test(this.state.password)
                              ? 'green'
                              : 'red'
                          }`,
                        }}
                      >
                        <img
                          src="https://webchat.bookmebob.com/res/close_cross.png"
                          width={10}
                          height={10}
                        ></img>
                        <span className="ml-2">Have atleast one number</span>
                      </p>
                      <p
                        className="text-start"
                        style={{
                          color: `${
                            /(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(
                              this.state.password
                            )
                              ? 'green'
                              : 'red'
                          }`,
                        }}
                      >
                        <img
                          src="https://webchat.bookmebob.com/res/close_cross.png"
                          width={10}
                          height={10}
                        ></img>
                        <span className="ml-2">
                          Have atleast one special character
                        </span>
                      </p>
                    </Tooltip>

                    {this.state.password !== '' && (
                      <div className="">
                        <PasswordStrengthBar
                          minLength={12}
                          password={this.state.password}
                        ></PasswordStrengthBar>
                      </div>
                    )}
                    <div className="d-flex justify-content-end align-items-center mt-4">
                      <Button
                        color="primary"
                        className="btn-shadow"
                        size="lg"
                        onClick={() => this.onUserRegister()}
                      >
                        <IntlMessages id="user.register-button" />
                      </Button>
                    </div>
                  </Form>
                </div>
              )}
              {this.state.success && (
                <div className="form-side">
                  <NavLink to={`/`} className="white">
                    {this.state?.contentArea2 ? (
                      parse(this.state?.contentArea2)
                    ) : (
                      <span className="logo-single">
                        {' '}
                        <img src={myma_logo} width="150" height="100" />{' '}
                      </span>
                    )}
                  </NavLink>
                  <CardTitle className="mb-4">
                    Your account is created successfully. Now you can login to
                    dashboard.
                    <NavLink
                      to="#"
                      style={{ padding: '0px', marginLeft: '5px' }}
                      onClick={(e) => this.redirectAction()}
                      className="btn btn-link btn-empty btn-lg active"
                    >
                      CLICK HERE
                      <i className="simple-icon-arrow-right" />
                    </NavLink>
                  </CardTitle>
                </div>
              )}
            </Card>
          </Colxx>
        </Row>
        <Modal
          isOpen={this.state.isShow}
          toggle={() => this.setState({ isShow: !this.state.isShow })}
        >
          <ModalHeader
            toggle={() => this.setState({ isShow: !this.state.isShow })}
          >
            Password
          </ModalHeader>
          <ModalBody>
            <h6 className="m-2">
              {' '}
              Password length must be in between of 12 to 16 character and its
              must have atleast 1 upper case, 1 lower case, 1 digit and 1
              special character.
            </h6>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => this.setState({ isShow: !this.state.isShow })}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(mapStateToProps, {
  registerUser,
})(Register);
